module.exports = __webpack_public_path__ + "img/member-photo-1.de4dec5c.jpg";